import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const GCLID = 'gclid';

/**
 * Google Click ID (GCLID)
 *  - GCLID is used to track google ad campaigns, the most recent GCLID will be saved into local storage and used in tracking events
 *  - This is passed to Itasca when making a checkout session which allows us to store it on stripe subscription events
 */
export const useGoogleClickId = () => {
  const params = useSearchParams();

  useEffect(() => {
    const gclid = params?.get('gclid');

    if (!gclid || typeof gclid !== 'string') {
      return;
    }

    if (localStorage.getItem(GCLID) !== gclid) {
      localStorage.setItem(GCLID, gclid);
    }
  }, [params]);
};
